import styled from "styled-components";
import Kevin from "../../images/DSC5381_1584x396.jpg";

const StyledHeader = styled.header`
  display: block;
  background-image: linear-gradient(rgba(0, 0, 0, 0.77), rgba(0, 0, 0, 0.50)), url(${Kevin});
  background-color: #484848;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;
  height: 100vh;

  .home_wrapper {
    position: relative;
    top: 0;
    display: flex;
    height: 100vh;
    justify-content: center;
    align-items: center;
  }

  .home_intro {
    display: block;
    text-align: center; /*Allows text wrapped on center for small screens*/
  }

  .text-color-white {
    color: #ffffff;  !important;
  }

  .text-shadow-bottom {
    text-shadow: 5px 5px 7px #000000;
  }

  .heading-style-h2 {
    font-size: 3rem;
    line-height: 1.2;
  }

  @media screen and (max-width: 767px) {
    .heading-style-h2 {
      font-size: 2rem;
    }
  }

  .heading-large {
    font-size: 4.5rem;
  }

  .heading-small {
    font-size: 2rem;
   }
  
  .heading-xsmall {
    font-size: 1.5rem
  }

  .mt-small {
    margin-top: 1.5rem !important;
  }

  .mt-xxsmall {
    margin-top: 0.5rem !important;
  }
  
  .tw-bold {
    font-weight: 700 !important;
  }

`

export default StyledHeader;